import { FormControl } from "@/form";
import { SingleSubselect, SingleSubselectListener, TreeSelection } from "./tree-select";

/** Adapts form controls for use in selecting a single option at a given level of the tree. */
export class TreeControl implements SingleSubselect {

    private callbacks: SingleSubselectListener | null = null;

    constructor(
        public readonly control: FormControl,
    ) {}

    get name(): string {
        return this.control.getName();
    }

    get value(): string {
        return this.control.getValue();
    }

    set value(value: string) {
        this.control.setValue(value);
    }

    getSubselectContainer(selection: TreeSelection): HTMLElement | null {
        return selection.treeElement.querySelector<HTMLElement>(`[data-level="${selection.path.level}"]`);
    }

    connect(listener: SingleSubselectListener): void {
        this.callbacks = listener;
        this.control.element.addEventListener('change', this.onChange);
    }

    disconnect(): void {
        this.callbacks = null;
        this.control.element.removeEventListener('change', this.onChange);
    }

    private onChange = () => {
        this.callbacks?.onValueChange(this);
    }
}